"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
function getBars(size) {
    var bars = [];
    var barCount = size === 'small' ? 3 : 5;
    for (var i = 0; i < barCount; i++) {
        bars.push({ id: i });
    }
    return bars;
}
function LoadingBars(props) {
    var size = props.size, color = props.color;
    var classes = classNames('loading-bars', {
        'loading-bars--small': size === 'small',
        'loading-bars--large': size === 'large',
        'loading-bars--fluid': size === 'fluid',
        'loading-bars--white': color === 'white',
        'loading-bars--orange': color === 'orange',
    });
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: "loading-bars__inner" }, getBars(size).map(function (wing) { return (React.createElement("div", { key: wing.id, className: "loading-bars__bar" })); }))));
}
exports.default = LoadingBars;
//# sourceMappingURL=loading_bars.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/loading_bars.js
// module id = JMWv
// module chunks = 20 21 22 23